import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { SuperGroup } from '../../shared/models/super-group.model';
import { LogService } from 'src/app/shared/services/log.service';

@Injectable({ providedIn: 'root' })
export class SuperGroupService {
  apiHost: string = environment.apiHost;
  superGroupArr: SuperGroup[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  async loadSuperGroups() {
    this.superGroupArr = await this.getAllSuperGroups();
    if (this.superGroupArr == null) this.superGroupArr = [];
    this.superGroupArr = this.superGroupArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }

  async loadActiveSuperGroups() {
    this.superGroupArr = await this.getActiveSuperGroups();
    if (this.superGroupArr == null) this.superGroupArr = [];
    this.superGroupArr = this.superGroupArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }

  getActiveSuperGroups(): Promise<SuperGroup[]> {
    let promise = new Promise<SuperGroup[]>((resolve, reject) => {
      return this.http
        .get<SuperGroup[]>(this.apiHost + '/SuperGroup/GetActive')
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Active SuperGroups', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllSuperGroups(): Promise<SuperGroup[]> {
    let promise = new Promise<SuperGroup[]>((resolve, reject) => {
      return this.http 
        .get<SuperGroup[]>(this.apiHost + '/SuperGroup/getall')
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All SuperGroups', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addSuperGroup(SuperGroup: SuperGroup): Promise<SuperGroup> {
    let promise = new Promise<SuperGroup>((resolve, reject) => {
      return this.http
        .post<SuperGroup>(this.apiHost + '/SuperGroup/add', SuperGroup)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add SuperGroup', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  saveSuperGroup(SuperGroup: SuperGroup): Promise<SuperGroup> {
    let promise = new Promise<SuperGroup>((resolve, reject) => {
      return this.http
        .post<SuperGroup>(this.apiHost + '/SuperGroup/update', SuperGroup)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update SuperGroup', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteSuperGroup(SuperGroupId: number): Promise<SuperGroup> {
    let promise = new Promise<SuperGroup>((resolve, reject) => {
      return this.http
        .post<SuperGroup>(
          this.apiHost +
            '/SuperGroup/delete?SuperGroupId=' +
            SuperGroupId.toString() +
            '&ShowHide=false',
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Delete SuperGroup', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  undeleteSuperGroup(SuperGroupId: number): Promise<SuperGroup> {
    let promise = new Promise<SuperGroup>((resolve, reject) => {
      return this.http
        .post<SuperGroup>(
          this.apiHost +
            '/SuperGroup/delete?SuperGroupId=' +
            SuperGroupId.toString() +
            '&ShowHide=true',
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Delete SuperGroup', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
